<template>
  <input
    class="ekkTimeCtrl"
    type="text"
    v-bind:value="MaskTime"
    @keydown="ProcessKey"
    @focus="SetFocus"
  />
</template>

<script>
export default {
  props: {
    value: { type: Date, required: true },
  },
  data() {
    return {
      time: this.value,
      keyNum: "",
    };
  },
  computed: {
    MaskTime() {
      return this.time.format("hh:mm tt");
    },
  },
  methods: {
    SetFocus(e) {
      if (e.target.selectionStart < 2) {
        window.setTimeout(function () {
          e.target.selectionStart = 0;
          e.target.selectionEnd = 2;
        }, 10);
      } else if (e.target.selectionStart < 6) {
        window.setTimeout(function () {
          e.target.selectionStart = 3;
          e.target.selectionEnd = 5;
        }, 100);
      } else {
        window.setTimeout(function () {
          e.target.selectionStart = 6;
          e.target.selectionEnd = 8;
        }, 10);
      }
    },
    ProcessKey(e) {
      //console.log(e.target.selectionStart);
      if (e.keyCode === 37) {
        if (e.target.selectionStart > 5) {
          window.setTimeout(function () {
            e.target.selectionStart = 3;
            e.target.selectionEnd = 5;
          }, 10);
        } else {
          window.setTimeout(function () {
            e.target.selectionStart = 0;
            e.target.selectionEnd = 2;
          }, 10);
        }
      } else if (e.keyCode === 39) {
        if (e.target.selectionStart < 2) {
          window.setTimeout(function () {
            e.target.selectionStart = 3;
            e.target.selectionEnd = 5;
          }, 10);
        } else {
          window.setTimeout(function () {
            e.target.selectionStart = 6;
            e.target.selectionEnd = 8;
          }, 10);
        }
      } else if (e.keyCode === 38) {
        if (e.target.selectionStart < 2) {
          this.time = this.time.addHours(1);
          window.setTimeout(function () {
            e.target.selectionStart = 0;
            e.target.selectionEnd = 2;
          }, 10);
        } else if (e.target.selectionStart < 6) {
          this.time = this.time.addMinutes(1);
          window.setTimeout(function () {
            e.target.selectionStart = 3;
            e.target.selectionEnd = 5;
          }, 10);
        } else {
          if (this.time.getHours < 12) {
            this.time = this.time.addHours(12);
          } else {
            this.time = this.time.addHours(-12);
          }
          window.setTimeout(function () {
            e.target.selectionStart = 6;
            e.target.selectionEnd = 8;
          }, 10);
        }
      } else if (e.keyCode === 40) {
        if (e.target.selectionStart < 2) {
          this.time = this.time.addHours(-1);
          window.setTimeout(function () {
            e.target.selectionStart = 0;
            e.target.selectionEnd = 2;
          }, 10);
        } else if (e.target.selectionStart < 6) {
          this.time = this.time.addMinutes(-1);
          window.setTimeout(function () {
            e.target.selectionStart = 3;
            e.target.selectionEnd = 5;
          }, 10);
        } else {
          if (this.time.getHours < 12) {
            this.time = this.time.addHours(12);
          } else {
            this.time = this.time.addHours(-12);
          }
          window.setTimeout(function () {
            e.target.selectionStart = 6;
            e.target.selectionEnd = 8;
          }, 10);
        }
      } else if (e.keyCode === 9) {
        //tab
      } else if (
        (!e.shiftKey && e.keyCode >= 48 && e.keyCode <= 57) ||
        (!e.shiftKey && e.keyCode >= 96 && e.keyCode <= 105)
      ) {
        this.keyNum += e.key;
        let t = new Date(this.time);
        if (e.target.selectionStart < 2) {
          t.setHours(this.keyNum);
          // console.log(t);
          this.time = t;
          window.setTimeout(function () {
            e.target.selectionStart = 0;
            e.target.selectionEnd = 2;
          }, 0);
        } else if (e.target.selectionStart < 6) {
        } else {
        }
        if (this.keyNum.length == 2) {
          this.keyNum = "";
        }
        e.preventDefault();
      } else {
        console.error(e);
        e.preventDefault();
      }

      this.$emit("input", this.time);
    },
  },
  watch: {
    value(newValue, oldValue) {
      this.time = newValue;
    },
  },
};
</script>
<style scoped>
.ekkTimeCtrl {
  width: 70px;
}
</style>


// WEBPACK FOOTER //
// src/components/ekkControls/Time.vue